// @flow
import React, { Component } from 'react';
import { StyleSheet } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import I18n from '../../../lib/i18n';
import { formatValue } from '../../../lib/usage-formatters';

class OptionZoneValidity extends Component<Props> {
  styles = getStyles();

  formatValue(value?: string, unit?: string) {
    if (!value || !unit) {
      return undefined;
    }

    return formatValue(value, unit);
  }

  render() {
    const { name, unit, value } = this.props;

    const textToDisplayKey = `optionZoneValidity.${name}`;
    if (!I18n.has(textToDisplayKey)) return null;

    return <Text style={this.styles.text}>{I18n.t(textToDisplayKey, { value: this.formatValue(value, unit) })}</Text>;
  }
}

const getStyles = () =>
  StyleSheet.create({
    text: {
      fontSize: 13,
      marginHorizontal: 25,
      marginTop: -9,
      fontWeight: '300',
    },
  });

type Props = {
  name: string,
  unit?: string,
  value?: string,
};

export default OptionZoneValidity;
